import { Component, OnInit } from "@angular/core";
import {
  NbMenuService,
  NbSidebarService,
  NbThemeService
} from "@nebular/theme";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { NbDialogService } from "@nebular/theme";

const redirectUri = `${window.location.origin}`;
import { Router } from "@angular/router";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
  public authUser: any;
  userPictureOnly: boolean = false;
  userMenu = [{ title: "Profile" }, { title: "Log out" }];
  currentTheme = "dark";
  private destroy$: Subject<void> = new Subject<void>();
  themes = [
    {
      value: "default",
      name: "Light"
    },
    {
      value: "dark",
      name: "Dark"
    },
    {
      value: "cosmic",
      name: "Cosmic"
    },
    {
      value: "corporate",
      name: "Corporate"
    }
  ];

  public nbContextMenuItems = [
    { title: "Sign In", data: { id: "sign-in", link: "/dashboard/home" } },
    { title: "Profile", data: { id: "profile", link: "/profile" } }
  ];

  constructor(
    private themeService: NbThemeService,

    private nbMenuService: NbMenuService,
    private sidebarService: NbSidebarService,
    private dialogService: NbDialogService,
    private router: Router
  ) {}

  async ngOnInit() {
    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe(themeName => (this.currentTheme = themeName));
  }
  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  async logout() {
    if (confirm("Are you sure you want to log out?")) {
    }
  }
  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "left");
    return false;
  }
}
